// extracted by mini-css-extract-plugin
export default {"colorDot":"styles---colorDot---vSiNu","colorDotTiny":"styles---colorDotTiny---Exom4","colorDotLarge":"styles---colorDotLarge---rn25L"};